<app-facet-list [title]="'FACETS.STANDARD'"
                [facets]="searchFacets"
                (selectFacet)="emitFacetFilter($event)">
</app-facet-list>
